import { useMutation } from "@tanstack/react-query";
import { deleteApplication } from "supabase/events/deleteApplication";
import { queryClient } from "utils";

export const useDeleteApplication = (onSuccess: () => any) => {
  const mutation = useMutation({
    mutationFn: ({ id }: { id: number }) => {
      return deleteApplication({ id });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["applications"] });
      onSuccess();
    },
  });

  return mutation;
};
